import { useContext } from "react";
import { LayoutListIcon as LayoutGroup } from "lucide-react";
import styles from "./elements.module.css";
import { TemplateContext } from "../../../../../../../../contexts/TemplateContext";
import { Template } from "../../../../../../../../sdkStructs";

export default function ElementsCard() {
  const { template, setTemplate } = useContext(TemplateContext);

  const handleFooterTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTemplate((prevTemplate: Template | null) => {
      if (prevTemplate === null) return null;
      return {
        ...prevTemplate,
        FooterText: e.target.value,
      };
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <LayoutGroup className={styles.icon} />
        <h1>Elements</h1>
      </div>

      <div className={styles.content}>
        <div className={styles.inputGroup}>
          <label htmlFor="text-input">Footer Text</label>
          <textarea
            id="text-input"
            value={template?.FooterText || ''}
            onChange={handleFooterTextChange}
            placeholder="Enter your footer text here..."
            className={styles.textarea}
          />
        </div>
      </div>
    </div>
  );
}